'use strict';

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = Object.assign({
  host: process.env.HOST || 'localhost',
  port: parseInt(process.env.PORT) || 3000,
  apiProtocol: process.env.APIPROTOCOL || 'http',
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: parseInt(process.env.APIPORT) || 3030,
  app: {
    title: '鏡傳媒 Mirror Media',
    description: '鏡傳媒以台灣為基地，是一跨平台綜合媒體，包含《鏡週刊》以及下設五大分眾內容的《鏡傳媒》網站，刊載時事、財經、人物、國際、文化、娛樂、美食旅遊、精品鐘錶等深入報導。我們以「鏡」為名，務求反映事實、時代與人性。'
  }
}, environment);


/*****************
 ** WEBPACK FOOTER
 ** ./server/config.js
 ** module id = 332
 ** module chunks = 0
 **/